export let settings: any;

export const loadSettings = () => fetch("/api/designer/getclientsettings")
    .then(reply => reply.json())
    .then(val => settings = val);


// WEBPACK FOOTER //
// ./src/settings.ts